import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2536ca9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "createTime" }
const _hoisted_4 = { style: {"padding":"0 0.16rem 0.16rem 0.16rem","font-size":"0.28rem"} }
const _hoisted_5 = { style: {"color":"red"} }
const _hoisted_6 = { class: "box mark" }
const _hoisted_7 = { class: "high-light" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ranking" }, "职场收入成本数据", -1))
const _hoisted_10 = {
  key: 1,
  class: "mark"
}
const _hoisted_11 = {
  class: "row",
  style: {
                background: '#E5F6F4',
                fontWeight: 600,
                padding: '10px',
                fontSize: '14px',
              }
}
const _hoisted_12 = { class: "grap" }

import { ref, watch, onMounted, nextTick } from "vue";
import { useRoute } from "vue-router";
import {
  CellGroup,
  Cell,
  Tabs,
  Tab,
  Overlay,
  Loading,
  Empty,
  Icon,
} from "vant";
import { formatPercentage, numToMoney } from "@/utils";
import createWatermark from "@/utils/watermark";
import dayjs from "dayjs";

import request from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  __name: 'CallMonthly',
  setup(__props) {

const visible = ref<boolean>(true);

const route = useRoute();
let time = dayjs(route?.params.time as string).format("YYYY-MM-DD");
const pageData = ref<any>([]);
const getPageData = async () => {
  const res = await request({
    url: `/api/wx/call/get-monthly-summary?startDay=${time}&endDay=${time}`,
    method: "POST",
    headers: {
      openId: sessionStorage.getItem("openid"),
    },
  });
  if (res.code === 200) {
    // showSuccessToast("保存成功！");
    pageData.value = res.data.summary;
    costData.value = res.data.detail;
    visible.value = true;
  } else {
    // showFailToast(res.data);
  }
};
getPageData();
const costData = ref<any>([]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "生成时间： " + _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY-MM-DD")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Icon), {
          size: "0.28rem",
          name: "warning-o",
          color: "red"
        }),
        _createTextVNode(" 下方数据为"),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(dayjs)(_unref(route).params.time as string).format("YYYY年MM月")), 1),
        _createTextVNode("的外呼供应商收入月报 ")
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(CellGroup), null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pageData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(Cell), {
                title: item.name,
                size: 'normal',
                "title-style": { width: '100px', flex: 'inherit' },
                key: index
              }, {
                value: _withCtx(() => [
                  _createElementVNode("span", _hoisted_7, [
                    _createTextVNode(_toDisplayString(item.type === "percentage"
                    ? _unref(formatPercentage)(item.value)
                    : _unref(numToMoney)(item.value)) + "（环比：", 1),
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: item.percentage >= 0 ? 'red' : 'green' })
                    }, _toDisplayString(`${item.percentage >= 0 ? "+" : ""}${_unref(formatPercentage)(
                      item.percentage
                    )}`), 5),
                    _createTextVNode("） ")
                  ])
                ]),
                _: 2
              }, 1032, ["title"]))
            }), 128))
          ]),
          _: 1
        }),
        _hoisted_8,
        _hoisted_9,
        (!costData.value.length)
          ? (_openBlock(), _createBlock(_unref(Empty), {
              key: 0,
              description: "暂无数据",
              "image-size": "100"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(costData.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  style: { borderBottom: '1px solid #ebedf0' },
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", {
                      class: _normalizeClass({
                  one: index == 0,
                  two: index == 1,
                  three: index == 2,
                  other: index > 2,
                })
                    }, _toDisplayString(index + 1), 3),
                    _createTextVNode(" " + _toDisplayString(item.workplace), 1)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", null, "收入总额: " + _toDisplayString(_unref(numToMoney)(item.grossRevenue)), 1),
                    _createElementVNode("div", null, "不含税收入: " + _toDisplayString(_unref(numToMoney)(item.excludingTaxIncome)), 1),
                    _createElementVNode("div", null, "不含税成本: " + _toDisplayString(_unref(numToMoney)(item.excludingTaxCost)), 1),
                    _createElementVNode("div", null, "毛利: " + _toDisplayString(_unref(numToMoney)(item.grossProfit)), 1)
                  ])
                ]))
              }), 128))
            ]))
      ])
    ], 512), [
      [_vShow, visible.value]
    ]),
    _createVNode(_unref(Overlay), {
      class: "overlay",
      show: !visible.value
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Loading), { type: "spinner" })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})